import {
  Button,
  Tabbar,
  TabbarItem,
  Toast,
  Tab,
  Tabs,
  Picker,
  DropdownMenu,
  DropdownItem,
  PullRefresh,
  Dialog,
  Overlay,
  Popup,
  DatetimePicker,
  Field,
  Cell,
  CellGroup,
  Uploader,
  RadioGroup,
  Radio,
  Form,
  Loading,
  Icon as VIcon,
  Swipe,
  SwipeItem,
  List,
  Checkbox,
  Calendar,
  Search,
  ActionSheet,
    Sticky,
  cascader,
    Popover,
} from 'vant';
import 'vant/lib/index.css';
import Avatar from '@/components/Avatar.vue'
import _ from 'lodash';
import ShopIcon from '../components/shopIcon'
import SwitchCalendar from '../components/SwitchCalendar'
import Icon from '../components/icon/index.vue';
import DatePicker from '../components/DatePicker.vue';
import DredgeVip from '../components/DredgeVip.vue';
import NoneData from '../components/NoneData.vue';
import DredgeVipDefault from '../components/DredgeVipDefault.vue';
import DredgeVipAnchor from '../components/DredgeVipAnchor.vue';
import liveNoneData from '../components/liveNoneData.vue';
import ShoppingCar from '../components/ShoppingCar.vue';
import AnchorContact from '../components/AnchorContact.vue';
import More from '../components/More.vue';
import LoginOrPayView from '../components/LoginOrPayView.vue';
import MobileNoneMore from '../components/MobileNoneMore.vue';
import AddCollection from '../components/AddCollection.vue';
import AnchorHeader from '../components/AnchorHeader.vue';
import ToggleView from '../components/ToggleView.vue';
import LoginModule from '@/components/LoginModule';
import BlurImage from "@/components/BlurImage";
import SVGIcon from "@/components/SVGIcon";
import GoToLink from "@/components/GoToLink";

import { get, post, del, put, patch } from '../api/index';

import {
  retainWan,
  splitWan,
  splitCoin,
  dateLong,
  someDaysBetween,
  indentation,
  sum,
  sixTable,
  goTop,
  updatedAtTime,
  returnPosition,
  checkMobilTypeof,
  kuaibiCoin,
  removeWxShare,
  getImage,
  percentage,
  changeCDN,
  formatTime,
    dateLongDuration
} from './helper';
import showNoneMonitor from '../helper/noneMonitor';
import axios from 'axios'
const plugins = {
  //注册
  install(Vue) { 
    Vue.use(Button);
    Vue.use(Popover);
    Vue.use(cascader);
    Vue.use(Sticky);
    Vue.use(Calendar);
    Vue.use(ActionSheet);
    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.use(Toast);
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Picker);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(PullRefresh);
    Vue.use(Search);
    Vue.use(Dialog);
    Vue.use(Overlay);
    Vue.use(Checkbox);
    Vue.use(Popup);
    Vue.use(DatetimePicker);
    Vue.use(Field);
    Vue.use(Uploader);
    Vue.use(Cell).use(CellGroup);
    Vue.use(RadioGroup);
    Vue.use(Radio);
    Vue.use(Form);
    Vue.use(Loading);
    Vue.use(VIcon);
    Vue.use(Swipe);
    Vue.use(SwipeItem);
    Vue.use(List);
    
    Vue.component('GoToLink', GoToLink);
    Vue.component('SVGIcon', SVGIcon);
    Vue.component('Icon', Icon);
    Vue.component('SwitchCalendar', SwitchCalendar);
    Vue.component('DatePicker', DatePicker);
    Vue.component('DredgeVip', DredgeVip);
    Vue.component('NoneData', NoneData);
    Vue.component('DredgeVipDefault', DredgeVipDefault);
    Vue.component('DredgeVipAnchor', DredgeVipAnchor);
    Vue.component('liveNoneData', liveNoneData);
    Vue.component('ShoppingCar', ShoppingCar);
    Vue.component('AnchorContact', AnchorContact);
    Vue.component('More', More);
    Vue.component('LoginOrPayView', LoginOrPayView);
    Vue.component('MobileNoneMore', MobileNoneMore);
    Vue.component('AddCollection', AddCollection);
    Vue.component('AnchorHeader', AnchorHeader);
    Vue.component('ToggleView', ToggleView);
    Vue.component('LoginModule', LoginModule);
    Vue.component('ShopIcon', ShopIcon);
    Vue.component('BlurImage',BlurImage)
    Vue.component('Avatar',Avatar)
    Vue.prototype.$axios = axios
    Vue.prototype.$get = get;
    Vue.prototype.$post = post;
    Vue.prototype.$del = del;
    Vue.prototype.$put = put;
    Vue.prototype.$patch = patch;
    Vue.prototype.$sum = sum;
    Vue.prototype.$_ = _;
    Vue.prototype.$retainWan = retainWan;
    Vue.prototype.$splitWan = splitWan;
    Vue.prototype.$splitCoin = splitCoin;
    Vue.prototype.$kuaibiCoin = kuaibiCoin;
    Vue.prototype.$dateLong = dateLong;
    Vue.prototype.$someDaysBetween = someDaysBetween;
    Vue.prototype.$indentation = indentation;
    Vue.prototype.$sixTable = sixTable;
    Vue.prototype.$goTop = goTop;
    Vue.prototype.$updatedAtTime = updatedAtTime;
    Vue.prototype.$returnPosition = returnPosition;
    Vue.prototype.$checkMobilTypeof = checkMobilTypeof;
    Vue.prototype.$showNoneMonitor = showNoneMonitor;
    Vue.prototype.$removeWxShare = removeWxShare;
    Vue.prototype.$dateLongDuration = dateLongDuration;
    Vue.prototype.$getImage = getImage;
    Vue.prototype.$percentage = percentage;
    Vue.prototype.$changeCDN = changeCDN;
    Vue.prototype.$formatTime = formatTime;
    Vue.prototype.$defaultSrc = 'https://s6.bihukankan.com/common/default.png';
    Vue.prototype.$showLoading = (message = '正在为您加载数据',options = {}) => {
      Toast.loading({
        message,
        duration: 0,
        loadingType: 'spinner',
        className: 'toast-no-dialog',
        ...options
      });
    };

    Vue.prototype.$showLoadingNoneText = () => {
      Toast.loading({
        message: '',
        duration: 0,
        loadingType: 'spinner'
      });
    };

    Vue.prototype.$hideLoading = () => {
      Toast.clear();
    };
  }
};
export default plugins;
